import { useLocation } from "react-router-dom";

import { useGetUrlSearchParams } from "seneca-common/utils/hooks/routing";

import { QUERY_PARAMS } from "features/teachers/features/class-sharing/hooks/useInviteQueryParamsValid";
import { MODAL_ROUTES } from "routing/routes";

import SignInCardCommon, { SignInCardCommonProps } from "../SignInCardCommon";

type Props = SignInCardCommonProps;

export default function SignInCardTeacherClassInvite(props: Props) {
  const location = useLocation();
  const query = useGetUrlSearchParams(location);
  const classId = query.get(QUERY_PARAMS.classId) as string;
  const email = query.get(QUERY_PARAMS.email) as string;

  return (
    <SignInCardCommon
      {...props}
      prefilledEmail={email}
      headerMessage={`${props.action} to join this class`}
      redirectAuthenticatedUserTo={MODAL_ROUTES.INVITE_TO_CLASS.buildPath(
        {},
        {
          classId
        }
      )}
    />
  );
}
